import React, { Fragment, Suspense } from "react";
import { metaTag } from "../Library/commomLib";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
const UserInfoComponent = React.lazy(() => import("../Components/RootComponents/UserInfoComponent"));
const UserInfoPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <UserInfoComponent />
      </Suspense>
    </Fragment>
  );
};

export default UserInfoPage;
